import {
  IconButton,
  Input,
  InputGroup,
  type InputGroupProps,
  type InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import React from "react";
import { CloseIcon } from "@/components/icons";

export interface InputStyledProps extends InputProps {
  leftElement?: React.JSX.Element;
  rightElement?: React.JSX.Element;
  fullW?: boolean;
  groupProps?: InputGroupProps;
  showBoxShadow?: boolean;
  clearBtn?: boolean;
  onClear?: () => void;
  filterMathSigns?: boolean;
}

export const InputStyledBase = React.forwardRef<HTMLInputElement, InputStyledProps>(
  function InputStyledBase(props, ref) {
    const {
      leftElement,
      rightElement,
      fullW,
      groupProps,
      showBoxShadow = true,
      clearBtn,
      onClear,
      borderColor,
      filterMathSigns,
      ...rest
    } = props;

    return (
      <InputGroup display="inline-flex" w={fullW ? "100%" : "initial"} {...groupProps}>
        {leftElement}
        <Input
          ref={ref}
          size="sm"
          borderRadius=".75rem"
          border="1px solid"
          borderColor={borderColor ?? (showBoxShadow ? "whiteAlpha.300" : "gray-base-04")}
          bg="transparent"
          boxShadow={showBoxShadow ? "0 2px 8px #00000014" : undefined}
          _hover={{
            borderColor: "brand.500",
          }}
          _focus={{
            borderColor: "brand.500",
            backgroundColor: "brand-bg-primary",
            boxShadow: "none",
          }}
          _focusVisible={{
            borderColor: "brand.500",
            boxShadow: "none",
          }}
          _dark={{ _placeholder: { color: "whiteAlpha.600" } }}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (!filterMathSigns) {
              return;
            }

            if (["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          {...rest}
        />
        {rightElement}
        {clearBtn && (
          <InputRightElement h="100%" w="34px" px="5px" color="gray-base-06">
            <IconButton
              aria-label={""}
              variant={"link"}
              height={"100%"}
              width={"100%"}
              minW={"unset"}
              onClick={onClear}
            >
              <CloseIcon size={18} />
            </IconButton>
          </InputRightElement>
        )}
      </InputGroup>
    );
  },
);

export const InputStyled = React.memo(InputStyledBase);
